import { Content, isFilled } from "@prismicio/client";

export const resolveSiteSettings = (document: Content.SiteSettingsDocument | null) => ({
  isMaintenanceMode: document?.data.isMaintenanceMode || false,
  notifications: (document?.data.notifications || []).filter((notification) => isFilled.richText(notification.content)),
});
